._100x20e0 {
  transition: background-color 0.2s;
  position: relative;
}
._100x20e0[role="link"] {
  cursor: pointer;
}
._100x20e0[data-highlighted] {
  background-color: #DDD4F533;
}
._100x20e0[data-deleted] {
  opacity: 0.7;
}
._100x20e1 {
  display: grid;
  grid-auto-rows: minmax(min-content, max-content);
  padding: 16px;
  grid-template-areas: 
      "top-header"
      "header"
      "reputation"
      "content"
      "footer"
      "hidden"
    ;
}
._100x20e2 {
  grid-area: header;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--_1qu8za21);
  min-width: 0;
  display: flex;
  align-items: start;
}
._100x20e3 {
  padding-bottom: 16px;
  display: flex;
  align-content: center;
  align-items: center;
}
._100x20e4:hover {
  text-decoration: underline;
}
._100x20e5 {
  display: flex;
  flex-direction: column;
}
._100x20e6 {
  padding-left: 8px;
  font-size: 12px;
}
._100x20e7 {
  display: flex;
  row-gap: 14px;
  min-width: 0;
  flex-direction: column;
}
._100x20e8 {
  margin-left: auto;
}
._100x20e9 {
  grid-area: content;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
}
._100x20ea {
  flex-grow: 1;
}
._100x20eb {
  flex-grow: 1;
}
._100x20eb a {
  pointer-events: none;
}
._100x20ec {
  min-height: 110px;
}
._100x20ed {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za25);
}
._100x20ee {
  grid-area: footer;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid var(--_1qu8za21);
  padding-top: 12px;
  row-gap: 8px;
  min-width: 0;
  flex-direction: column;
}
._100x20ef {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scrollbar-width: none;
  align-items: center;
}
._100x20eg {
  display: flex;
  gap: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 24px;
  flex-wrap: wrap;
}
._100x20eh {
  display: flex;
  gap: 8px;
  align-items: center;
}
@media screen and (min-width: 768px) {
  ._100x20e1 {
    padding: 32px 32px 24px 32px;
    grid-template-areas: 
      "top-header top-header"
      "header header"
      "content reputation"
      "footer footer"
      "hidden hidden"
    ;
    grid-template-columns: 1fr auto;
  }
  ._100x20e2 {
    align-items: center;
  }
  ._100x20e7 {
    flex-direction: row;
  }
  ._100x20e9 {
    padding-right: 24px;
  }
}
@media screen and (min-width: 1280px) {
  ._100x20e1 {
    padding: 32px 40px 24px 40px;
  }
  ._100x20e9 {
    padding-right: 32px;
  }
  ._100x20ee {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: center;
  }
  ._100x20ef {
    padding-left: 24px;
  }
  ._100x20eg {
    border-right: 1px solid var(--_1qu8za21);
  }
}